export default __webpack_public_path__ + "assets/bosnia-and-herzegovina-flag.png";